import { Button, Center, Stack, Text, Title } from '@mantine/core';

type Props = {
  onRetry: () => void;
};

/**
 * @desc Shown when the sign-in redirect could not be started — almost always a
 * browser blocking cookies and site data, which AuthKit needs to hold its PKCE
 * verifier. See `useSignInRedirect`.
 */
export function SignInUnavailable({ onRetry }: Props) {
  return (
    <Center h="100dvh" p="md" data-testid="sign-in-unavailable">
      <Stack align="center" gap="sm" maw={420} ta="center">
        <Title order={3}>Can&rsquo;t start sign-in</Title>
        <Text c="dimmed" size="sm">
          Signing in needs cookies and site data for this site. Allow them in your browser settings,
          or try a window that isn&rsquo;t in private mode, then retry.
        </Text>
        <Button mt="xs" onClick={onRetry}>
          Retry
        </Button>
      </Stack>
    </Center>
  );
}
